module.exports = __webpack_public_path__ + "static/media/diarmuid-reil-architects.13bfd23c.png";